import React from 'react'

type Props = {
  data: any
}
const BusinessDetailsPage: React.FC<Props> = ({ data }) => {
  const convertCompanySize = (companySize: any) => {
    const ranges: any = {
      belowTwenty: 'Below 20',
      twentyOneToFifty: '21 to 50',
      fiftyOneToTwoHundred: '51 to 100',
      twoHundredOneToFiveHundred: '201 to 500',
      fiveHundredOneToThousand: '501 to 1000',
      thousandPlus: '1000+'
    }

    return ranges[companySize] || companySize
  }

  return (
    <div className='card'>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        {/* Card header */}
        <div className='card-header cursor-pointer'>
          {/* Card title */}
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>Business Details</h3>
          </div>
        </div>
        {/* Card header */}

        {/* Card body */}

        <div className='card-body p-9'>
          {/* Row */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>Franchise Name</label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-bold fs-6 text-gray-800'>{data?.getFranchise?.name}</span>
            </div>
          </div>
          {/* Row */}

          {/* Input group */}
          {/* <div className='row mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>Team Size</label>
           
            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bold fs-6 text-gray-800 me-2'>{data.getFranchise.teamSize}</span>
            </div>
          </div> */}
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>Company Size</label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>
                {convertCompanySize(data?.getFranchise?.companySize)}
              </span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>Registered Address</label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>
                {data?.getFranchise?.registeredAddress}
              </span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>Date of Incorporation</label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>
                {data?.getFranchise?.dateOfIncorporation}
              </span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>Business Contact Number</label>

            {/* Col */}
            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bold fs-6 text-gray-800 me-2'>
                {data?.getFranchise?.businessContactNumber}
              </span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>
              CIN (Corporate Identification Number)
            </label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>{data?.getFranchise?.CIN}</span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>
              PAN (Permanent Account Number)
            </label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>{data?.getFranchise?.PAN}</span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>
              TAN (Tax Deduction and Collection Account Number)
            </label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>{data?.getFranchise?.TAN}</span>
            </div>
          </div>
          {/* Input group */}

          {/* Input group */}
          <div className='row mb-7'>
            {/* Label */}
            <label className='col-lg-4 fw-semibold text-muted'>
              GSTIN (Goods and Services Tax Identification Number)
            </label>

            {/* Col */}
            <div className='col-lg-8'>
              <span className='fw-semibold text-gray-800 fs-6'>{data?.getFranchise?.GSTIN}</span>
            </div>
          </div>
          {/* Input group */}
        </div>
        {/* Card body */}
      </div>
    </div>
  )
}

export default BusinessDetailsPage
